import React from 'react';
import Button from '../atoms/Button';
import SelectDropdown from '../atoms/SelectDropdown';
import UserTable from '../organisms/UserTable';
import { User } from '../types/User';
import Pluse_square from '../../static/svg/Pluse_square';
import SectionHeader from '../molecules/SectionHeader';
import WindowHeightComponent from '../../Layouts/WindowHeight';

interface UserPageTemplateProps {
  users: User[];
  dropdownUsers: string[];
  selectedUsername: string;
  roleOptions: { label: string; value: string }[];
  onUserSelect: (username: string) => void;
  onRoleChange: (username: string, roles: string) => void;
  onSaveAll: () => void;
  clientErrors: string[]
}

const UserPageTemplate: React.FC<UserPageTemplateProps> = ({
  users,
  dropdownUsers,
  selectedUsername,
  roleOptions,
  onUserSelect,
  onRoleChange,
  onSaveAll,
  clientErrors
}) => {
  const handleFilter = () => {

  }
  return (
    <>

      {clientErrors.length > 0 && (
        <div className="alert alert-danger">
          <ul>
            {clientErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}

          </ul>
        </div>
      )}
      <WindowHeightComponent className={''}>
        <div className="p-3">
          <div className="d-flex align-items-center mb-3">
            <SelectDropdown
              id="user-select"
              name="user-select"
              options={dropdownUsers.map((user) => ({ name: user, value: user }))}
              value={selectedUsername}
              onChange={(e) => onUserSelect(e.target.value)}
              className="form-select"
            />
            
          </div>
          <UserTable
            users={users}
            roleOptions={roleOptions}
            onRoleChange={onRoleChange}
            onSaveAll={onSaveAll}
          />
        </div>
      </WindowHeightComponent>

    </>
  )
}

export default UserPageTemplate;
